export const internalOrderMixin = {
    computed: {
        orderId() {
            return this.$store.getters['smartLogisticWarehouse/curOrderId']
        },

        isLoading() {
            return this.$store.getters['smartLogisticWarehouse/isLoading'](this.orderId)
        },

        isUpdating() {
          return this.$store.getters['smartLogisticWarehouse/isUpdatingItem'] || this.$store.getters['smartLogisticWarehouse/isCompletingPartialOrder']
        },

        isReady() {
            return this.order !== undefined && this.partialDeliveries !== undefined
        },

        isOrderCompleted() {
            return this.order.status === 'done'
        },

        order() {
            return this.$store.getters['smartLogisticWarehouse/orderById'](this.orderId)
        },

        orderItems() {
            return this.order.items.filter(i => i.quantity > 0)
        },

        standardItems() {
            if(this.isOrderCompleted) {
                return this.orderItems.filter(i => !i.collective || i.storageLocation === 'floor')
            }

            const ids =  this.currentlyOpenPartialDelivery.items.filter(i => !i.collective || i.storageLocation === 'floor').map(i => i.artikelNrLAG)


            return this.orderItems.filter(i => ids.includes(i.artikelNrLAG))

        },

        collectiveItems() {
            if(this.isOrderCompleted) {
                return this.orderItems.filter(i => i.collective && i.storageLocation === 'warehouse')
            }

            const ids = this.currentlyOpenPartialDelivery.items.filter(i => i.collective && i.storageLocation === 'warehouse').map(i => i.artikelNrLAG)

            return this.orderItems.filter(i => ids.includes(i.artikelNrLAG))
        },

        partialDeliveries() {
            const partialDeliveries = this.$store.getters['smartLogisticWarehouse/partialDeliveriesById'](this.orderId)

            if(!partialDeliveries) {
                return []
            }

            return partialDeliveries
        },

        completedPartialDeliveries() {
            return this.partialDeliveries.filter(pd => pd.status === 'submitted').sort((a, b) => a.date <= b.date ? 1 : -1)
        },

        currentlyOpenPartialDelivery() {
            if(this.isOrderCompleted) {
                // return this.partialDeliveries[ this.partialDeliveries.length - 1 ]
                return this.partialDeliveries[0]
            }

            return this.partialDeliveries.find(pd => ['draft', 'edited'].includes(pd.status))
        },

        isFirstPartialDelivery() {
          return this.partialDeliveries.length === 1
        },
    },

    methods: {
        currentlyPickedFor(artikelNrLAG, ownerType, ownerId) {
            return this.currentlyOpenPartialDelivery.items.find(i => i.artikelNrLAG == artikelNrLAG && i.ownerType === ownerType && i.ownerId == ownerId)
        },

        totalPickedFor(artikelNrLAG, ownerId, ownerType) {
            return this.completedPartialDeliveries.reduce((total, partialDelivery) => {
                return total + partialDelivery.items.filter(i => i.ownerType === ownerType && i.ownerId == ownerId && i.artikelNrLAG == artikelNrLAG).reduce((total, p) => total + p.delivered, 0)
            }, 0)

        },

        articlePicks(artikelNrLAG) {
            return this.currentlyOpenPartialDelivery.items.filter(i => i.artikelNrLAG == artikelNrLAG)
        },
    }
}
